import request from '@/utils/request'

//案例中心分页查询
export function planListPage(data) {
  return request({
    url: '/plan/getPlanListPage',
    method: 'post',
    data
  })
}

//删除单个案例
export function deletePlanByid(data) {
  return request({
    url: '/plan/deletePlanById',
    method: 'get',
    params: data
  })
}

//案例中心查看详情
export function projectId(data) {
  return request({
    url: '/plan/listByProjectId',
    method: 'post',
    data
  })
}
